import ContactLayout from "Layout/ContactLayout";
export default function Services() {
  return (
    <ContactLayout heading="Our Services">
      <div className="service_us">
        <div className="service_us_main">
          <div className="service_us_main_left">
            <div className="service_us_main_left_image">
              <img src="/image/house-1.jpeg" alt="service-hero-img" />
            </div>
          </div>
          <div className="service_us_main_right">
            <h1 className="service_us_main_title">Property Development</h1>
            <div className="service_us_main_text">
              We provide high-quality premium properties, that are
              professionally managed all over the world. We aim to provide real
              estate solutions that are of the highest standards globally and
              meet the needs of our clients at all times. We acquire, upgrade
              and then resell single-family homes that are probate and
              foreclosure properties at a significant profit.
            </div>
          </div>
        </div>
        <div className="service_us_secondary">
          <div className="service_us_secondary_left">
            <h1 className="service_us_secondary_title">
              {" "}
              Real Estate Consultancy{" "}
            </h1>
            <div className="service_us_secondary_text">
              Our firm provides our clients with the best location,
              infrastructure, and opportunities for long-term investments in
              real estate. Real estate operates with trust, enthusiasm, and a
              vision for change. We provide services for land acquisition,
              sales, and development that help create communities and improve
              the quality of life. We aim to empower you for the next generation
              for financial independence, by using a revolutionary new platform.
            </div>
          </div>
          <div className="service_us_secondary_right">
            <div className="service_us_secondary_right_image">
              <img src="/image/house-2.jpeg" alt="service-hero-img" />
            </div>
          </div>
        </div>
        <div className="service_us_main two">
          <div className="service_us_main_left">
            <div className="service_us_main_left_image">
              <img src="/image/house-1.jpeg" alt="service-hero-img" />
            </div>
          </div>
          <div className="service_us_main_right">
            <h1 className="service_us_main_title"> Land Banking </h1>
            <div className="service_us_main_text">
              Our mission is to help our clients achieve their financial goals.
              Our team works hard each day to earn our place in the market, and
              to become a trustworthy company that our clients can be proud of.
              We build and promote property investments, ranging from
              residential projects and apartments to private real estate asset
              management. We aim to provide our clients with high-quality
              services through a consistent application of innovative and proven
              techniques.
            </div>
          </div>
        </div>
        <div className="service_us_secondary">
          <div className="service_us_secondary_left">
            <h1 className="service_us_secondary_title">
              {" "}
              Kazfield Property Investment{" "}
            </h1>
            <div className="service_us_secondary_text">
              Our years of experience in real estate have helped many people
              find the perfect property to purchase. Our connections with top
              companies enable us to provide our clients with a variety of
              options to choose from. We are open to all types of buyers, either
              looking for an investment property or a place to call home; we are
              ready to help! Our services also include Mortgage advice, Legal
              advice, and more…
            </div>
          </div>
          <div className="service_us_secondary_right">
            <div className="service_us_secondary_right_image">
              <img src="/image/house-2.jpeg" alt="service-hero-img" />
            </div>
          </div>
        </div>
        <div className="service_us_main two">
          <div className="service_us_main_left">
            <div className="service_us_main_left_image">
              <img src="/image/house-1.jpeg" alt="service-hero-img" />
            </div>
          </div>
          <div className="service_us_main_right">
            <h1 className="service_us_main_title">Property marketing</h1>
            <div className="service_us_main_text">
              We are a property marketing agency with a passion for helping you
              make the most of your investment. We believe that every home
              should feel like a home and every property should feel like it
              belongs to you. That is why we take our time to get to know our
              clients and their real estate goals, dreams, personality,
              lifestyle, and what makes them special. Our goal is to create a
              marketing plan that will attract the right kind of buyers to your
              property and with the right motivation, they find it irresistible.
              We also help you negotiate the best possible price for your home.
              Our team is made up of real estate experts in marketing and
              design, who offers advice on how to maximize potential buyers, and
              visits and convince them to own the home.
            </div>
          </div>
        </div>
      </div>
    </ContactLayout>
  );
}
